import * as React from "react";

import { cn } from "@/lib/utils";

// Use the 16px body size on mobile; an explicit length survives text-color merging.
const inputClassName =
  "h-8 w-full min-w-0 rounded-lg border border-transparent bg-control px-2.5 py-1 text-[length:var(--text-body)] transition-colors outline-none hover:bg-control-hover file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-placeholder disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-60 md:text-sm";

type InputProps = React.ComponentPropsWithRef<"input">;

function Input({ className, type, ref, ...props }: InputProps) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot="input"
      className={cn(inputClassName, className)}
      {...props}
    />
  );
}

export { Input, inputClassName };
